import acordeon from "../lib/aria/acordeon";

const preguntasFrecuentes = () => {
    acordeon('.preguntas_frecuentes__lista');
}

export default preguntasFrecuentes;